import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';
interface SC_SlideButtonLineProps {
    color: 'white' | 'gray';
}
export interface SC_SlideButtonProps {
    point: {
        left: string;
        width: string;
    },
    color: string
}

export const SC_SlideButton = styled.div<SC_SlideButtonProps>`
    height: 32px;    
    border-radius: 2px;
    background: ${(props) => props.color};
    cursor: pointer;
    position: absolute;
    transition: 0.2s;
    align-items: center;
    justify-content: center;
    justify-content: space-around;
    display: flex;
    padding: 0 8px;    
    margin-top: -15px;
    left: ${(props) =>  props.point.left};
    width: ${(props) =>  props.point.width};
    box-shadow: 1px 2px ${theme.ZrColorNeutralMedium03};
`;

export const SC_SlideButtonLine = styled.div<SC_SlideButtonLineProps>`
    height: 15px; 
    width: 1px;
    opacity: 0.7;
    background-color: ${(props) => props.color === 'white' ? `${theme.ZrColorNeutralLightest}` : `${theme.ZrColorNeutralMedium03}`};
`;